import React, { useRef, useState } from 'react';
import { DraggableCore } from 'react-draggable';

import type { ReactNode, RefObject } from 'react';
import type {
  DraggableCoreProps,
  DraggableData,
  DraggableEvent,
} from 'react-draggable';

export type DraggableEventHandler = (
  e: DraggableEvent,
  data: DraggableData,
  context: any,
) => any | false;

export interface DraggableProps
  extends Omit<
    Partial<DraggableCoreProps>,
    'onStart' | 'onDrag' | 'onStop' | 'children'
  > {
  onStart: DraggableEventHandler;
  onDrag: DraggableEventHandler;
  onStop: DraggableEventHandler;
  children: (ref: RefObject<any>, context: any) => ReactNode;
}

export const Draggable: React.FC<DraggableProps> = props => {
  const [context, setContext] = useState();

  const nodeRef = useRef<HTMLElement>(null);

  return (
    <DraggableCore
      {...props}
      nodeRef={nodeRef}
      onStart={(e, data) => {
        const newContext = props.onStart(e, data, undefined);
        if (!newContext) {
          return newContext;
        }
        setContext(newContext);
      }}
      onDrag={(e, data) => {
        const newContext = props.onDrag(e, data, context);
        if (!newContext) {
          return newContext;
        }
        setContext(newContext);
      }}
      onStop={(e, data) => {
        setContext(undefined);
        props.onStop(e, data, context);
      }}
      // Avoid global style recalculation on click/drag
      // https://github.com/react-grid-layout/react-grid-layout/pull/1660
      enableUserSelectHack={props.enableUserSelectHack ?? false}
    >
      {props.children(nodeRef, context)}
    </DraggableCore>
  );
};
